import { Arbeitstage } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/tage';
import { Mitarbeiter_AnzahlArbeitstage } from '@/gql/graphql';

const anzahlArbeitstageMap: Record<
  keyof Arbeitstage,
  Mitarbeiter_AnzahlArbeitstage
> = {
  EIN_TAG: Mitarbeiter_AnzahlArbeitstage.EinTag,
  ZWEI_TAGE: Mitarbeiter_AnzahlArbeitstage.ZweiTage,
  DREI_TAGE: Mitarbeiter_AnzahlArbeitstage.DreiTage,
  VIER_TAGE: Mitarbeiter_AnzahlArbeitstage.VierTage,
  FUENF_TAGE: Mitarbeiter_AnzahlArbeitstage.FuenfTage,
  SECHS_TAGE: Mitarbeiter_AnzahlArbeitstage.SechsTage,
  SIEBEN_TAGE: Mitarbeiter_AnzahlArbeitstage.SiebenTage,
  FLEXIBEL: Mitarbeiter_AnzahlArbeitstage.Flexibel,
};

export function mapAnzahlArbeitstage(
  anzahl: keyof Arbeitstage | null,
): Mitarbeiter_AnzahlArbeitstage | null {
  if (!anzahl) {
    return null;
  }
  return anzahlArbeitstageMap[anzahl];
}
